import { useTranslation } from 'react-i18next';
import { InputSelect, Text } from '@pentabd/ui';

import { useElectionsType } from '@hooks/useElections';
import { modifiedElectionScheduleId } from '@helpers/modifiedElections';
import { Controller, useForm } from 'react-hook-form';
import { Dispatch, SetStateAction } from 'react';
import Spinner from './Spinner';

type ElectionSelectProps = {
  setParams: (params: { election_schedule_id: string }) => void;
  searchParams: URLSearchParams;
  setDivisionChartState?: any;
  onClose: () => void;
  handleQuery?: (name: string, value: string | number) => void;
  electionsData: useElectionsType;
  setElectionScheduleName: Dispatch<SetStateAction<string>>;
};

export const ElectionSelect = ({
  setParams,
  searchParams,
  setDivisionChartState,
  onClose,
  handleQuery,
  electionsData,
  setElectionScheduleName,
}: ElectionSelectProps) => {
  const { t } = useTranslation();
  const { control } = useForm();

  const { isLoading, elections } = electionsData;

  return (
    <div className="w-100" style={{ minHeight: '350px' }}>
      {isLoading ? (
        <div
          style={{ minHeight: '350px' }}
          className="w-100 d-flex align-items-center"
        >
          <div className="w-100 h-100 d-flex justify-content-center align-items-center ">
            <Spinner />
          </div>
        </div>
      ) : (
        <div className="w-100 row pt-10">
          <div className="col-12">
            <Text>{t('DASHBOARD.SELECT_ELECTIONS.LABEL')}</Text>
          </div>
          <div className="col-12">
            <Controller
              control={control}
              name="electionSelect"
              render={({ field }) => {
                return (
                  <InputSelect
                    options={modifiedElectionScheduleId(elections) || []}
                    name="electionSelect"
                    placeholder={t('DASHBOARD.SELECT_ELECTIONS.PLACEHOLDER')}
                    onSelectItem={(val) => {
                      const election_schedule_id = val?.toString() || '';
                      const query_election_schedule_id =
                        searchParams.get('election_schedule_id') || '';

                      if (query_election_schedule_id !== election_schedule_id) {
                        const selectedElection = elections.find(
                          // eslint-disable-next-line eqeqeq
                          (item) => item.election_schedule_id == val,
                        );

                        setElectionScheduleName(
                          selectedElection?.election_name_bn
                            ? selectedElection.election_name_bn
                            : '',
                        );

                        setDivisionChartState && setDivisionChartState([]);
                        handleQuery && handleQuery('division', '');
                        setParams({
                          election_schedule_id: election_schedule_id,
                        });
                        field.onChange(val);
                        onClose();
                      }
                    }}
                    portal={false}
                    defaultValue={
                      Number(searchParams.get('election_schedule_id')) ||
                      field.value
                    }
                    isSearchable
                  />
                );
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
